import { useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { hasPrivilege } from "../api/token";
import RouterCard from "../components/RouterCard";

function EditRouter() {
  const navigate = useNavigate();
  const params = useParams();
  const administration_edit = hasPrivilege('administration_edit');

  useEffect(() => {
    if (!administration_edit) {
      navigate("/");
    }
  }, [navigate, administration_edit])

  if (administration_edit) {
    return <RouterCard ident={params.id} editable={true} layer="full" />;
  }
}

export default EditRouter;
